import React from "react";
import { NodeTypesEnumSingleSelection } from "../../GeneralSelection";
import { SelectChangeEvent } from "../../MuiGenerals";
import { useTranslation } from "../../../hooks";
import { selectCrossMerchant } from "../../../reducer/crossMerchantSlice";
import { useAppSelector } from "../../../reducer/hooks";

interface IProps {
  label?: string;
  value: string;
  onChange: (e: SelectChangeEvent<string>) => void;
  onClearSelect: () => void;
}

const LPMerchantSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClearSelect } = props;
  const { t } = useTranslation("common");
  const { merchantMapping } = useAppSelector(selectCrossMerchant);
  return (
    <NodeTypesEnumSingleSelection
      label={label ?? t("ph_merchant_lp")}
      onChange={onChange}
      value={value}
      enumData={merchantMapping}
      nameFn={(name) => name}
      isNoSorting
      clearSelect={onClearSelect}
    />
  );
};

export default LPMerchantSingleSelection;
